"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Returns styled title of a section. On desktop is centered.
 * Renders if `description` has thruthy value.
 */ const Title = (param)=>{
    let { title, className } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!title) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        variant: "h4",
        component: "h2",
        color: "textPrimary",
        textAlign: "center",
        className: className,
        "data-testid": getTestId(_constants.TITLE),
        children: title
    });
};
exports.Title = Title;
